/* eslint-disable no-console */
type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'silent';

const levelOrder: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4,
};

const isLogLevel = (value: string): value is LogLevel =>
  value === 'debug' ||
  value === 'info' ||
  value === 'warn' ||
  value === 'error' ||
  value === 'silent';

const getCurrentLevel = (): LogLevel => {
  // const configuredLevel = 'error';
  const configuredLevel = process.env.REACT_APP_LOG_LEVEL?.trim().toLowerCase();
  if (!configuredLevel) {
    return 'info';
  }

  return isLogLevel(configuredLevel) ? configuredLevel : 'info';
};

const currentLevel = getCurrentLevel();

function shouldLog(level: LogLevel) {
  return levelOrder[level] >= levelOrder[currentLevel];
}

function timestamp() {
  return new Date().toISOString();
}

export const logger = {
  debug: (...args: unknown[]) => shouldLog('debug') && console.debug(`[${timestamp()}]`, ...args),
  info: (...args: unknown[]) => shouldLog('info') && console.info(`[${timestamp()}]`, ...args),
  warn: (...args: unknown[]) => shouldLog('warn') && console.warn(`[${timestamp()}]`, ...args),
  error: (...args: unknown[]) => shouldLog('error') && console.error(`[${timestamp()}]`, ...args),
};
